package com.milta.feature.profile.presentation

sealed interface ProfileNavEvent {
    data object NavigateBack : ProfileNavEvent
    data object SessionExpired : ProfileNavEvent
    data object AccountDeleted : ProfileNavEvent
}
